import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { ISelectOption } from 'app/models/filter-form.models';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
  selector: 'app-all-data-select-filter',
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.scss'],
  imports: [MatFormField, MatSelect, FormsModule, NgFor, MatOption],
})
export class AllDataSelectFilterComponent implements OnInit {
  @Input() set data(value: string[]) {
    this.value = value;
  }

  @Input() placeholder!: string;
  @Input() isSingle?: boolean;
  @Input() options?: ISelectOption[] = [];
  @Input() onClear!: Subject<void>;

  @Output() filterChange = new EventEmitter<string[]>();

  value: string[] = [];

  ngOnInit(): void {
    this.onClear.subscribe(() => {
      this.value = [];
    });
  }

  onFilterChange() {
    this.filterChange.emit(this.value);
  }
}
